/**
 * @file 个人积分概览组件
 */
import {Fragment} from 'react';
import styles from './PersonalPointsSummary.module.less';
import Icon from '@/components/common/Icon';
import Tooltip from '@/components/common/Tooltip';
import {usePersonalPoints} from '@/hooks/points/usePersonalPoints';
import type {PointsPersonalSummaryData} from '@/services/points/interface';

const SUMMARY_ITEMS: Array<{
    label: string;
    key: keyof PointsPersonalSummaryData;
    tip?: string;
    positive?: boolean;
}> = [
    {label: '个人余额', key: 'personalTotalRemaining'},
    {
        label: '项目余额',
        key: 'projectTotalRemaining',
        tip: '该用户所在项目的积分余额数值（包含该用户是负责人或成员的所有项目）',
    },
    {label: '累计投入', key: 'projectTotalAllocated', positive: true},
    {label: '累计消耗', key: 'projectTotalConsumed'},
];

const PersonalPointsContent: React.FC = () => {
    const {summary} = usePersonalPoints();

    return (
        <div className={styles.container}>
            {SUMMARY_ITEMS.map((item, index) => {
                const value = summary?.[item.key];
                const isPositive = item.positive && typeof value === 'number' && value > 0;

                return (
                    <Fragment key={item.key}>
                        {index > 0 && <div className={styles.divider} />}
                        <div className={styles.box}>
                            <div className={styles.label}>
                                {item.label}
                                {item.tip && (
                                    <Tooltip
                                        title={item.tip}
                                        placement="top"
                                        classNames={{
                                            root: styles.tooltipNoWrapRoot,
                                            container: styles.tooltipNoWrap,
                                        }}
                                    >
                                        <Icon
                                            name="AijBasicBeizhu"
                                            size={12}
                                            className={styles.tooltipIcon}
                                        />
                                    </Tooltip>
                                )}
                            </div>
                            <div
                                className={`${styles.value}${
                                    isPositive ? ` ${styles.valueGreen}` : ''
                                }`}
                            >
                                {isPositive && <span className={styles.prefix}>+</span>}
                                {value ?? '--'}
                            </div>
                        </div>
                    </Fragment>
                );
            })}
        </div>
    );
};

export default PersonalPointsContent;
